export default [
    {
        path: "/horas-extras",
        name: "horas-extras",
        component: () =>
            import(/* webpackChunkName: "horasExtras" */ "./listadoEmpleado.vue"),
    },
    {
        path: "/horas-extras-unidad",
        name: "horas-extras-unidad",
        component: () =>
            import(/* webpackChunkName: "horasExtras" */ "./listadoJunidad.vue"),
    },
    {
        path: "/horas-extras-unidad/expediente/:id",
        name: "horas-extras-expediente",
        component: () =>
            import(/* webpackChunkName: "horasExtras" */ "./components/ExpedienteComponents.vue"),
    },
    {
        path: "/horas-extras-unidad/detalle-solicitud/:id",
        name: "horas-extras-detalle-solicitud",
        component: () =>
            import(/* webpackChunkName: "horasExtras" */ "./components/DetalleSolicitud.vue"),
    },
    {
        path: "/horas-extras-unidad/nueva-solicitud/:id?",
        name: "nueva-solicitud-horas-extras",
        component: () =>
            import(/* webpackChunkName: "horasExtras" */ "./components/SolicitudHorasExtrasComponents.vue"),
    }
];